import React from 'react';
import { Box, Fab, makeStyles } from '@material-ui/core';
import PlaceIcon from '@material-ui/icons/Place';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DeleteIcon from '@material-ui/icons/Delete';
import BarChartIcon from '@material-ui/icons/BarChart';
import { Link as RouterLink, LinkProps as RouterLinkProps, useRouteMatch } from 'react-router-dom';

interface WasteLinkProps {
  to: string;
}

const WasteLink: React.FC<WasteLinkProps> = ({ to, children }) => {
  const classes = useStyles();
  let match = useRouteMatch(to);
  const renderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, 'to'>>((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to],
  );
  return (
    <Fab className={!!match ? classes.wasteLinkActive : ''} variant="extended" size="large" color="primary" component={renderLink}>
      <>{children}</>
    </Fab>
  );
}

interface WasteNavBarProps {
  float?: boolean
}

const WasteNavBar: React.FC<WasteNavBarProps> = ({ float, children }) => {
  const classes = useStyles();
  const addProps = float ? {
    position: "absolute",
    top: "0px",
  } : {};
  return (
    <Box px={3} py={3} {...addProps} width="100%" display="flex">
      <Box display="flex" flexGrow="1" maxWidth="580px">
        <Box mr={3}>
          <WasteLink to="/waste/jobs">
            <LocalShippingIcon className={classes.extendedIcon} />
              Jobs
            </WasteLink>
        </Box>
        <Box mr={3}>
          <WasteLink to="/waste/map">
            <DeleteIcon className={classes.extendedIcon} />
              Events
            </WasteLink>
        </Box>
        <Box mr={3}>
          <WasteLink to="/waste/truckroute">
            <PlaceIcon className={classes.extendedIcon} />
              Routes
            </WasteLink>
        </Box>
        <Box mr={3}>
          <WasteLink to="/waste/metrics">
            <BarChartIcon className={classes.extendedIcon} />
              Metrics
            </WasteLink>
        </Box>
      </Box>
      <Box flexGrow="1">
        {children}
      </Box>
    </Box>
  );
}
const useStyles = makeStyles((theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  dateText: {
    textAlign: "right",
    fontSize: "24px",
    lineHeight: "32px",
    color: theme.palette.info.main,
  },
  jobsLink: {
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  wasteLinkActive: {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default WasteNavBar;